// Helper to safely convert string to number for display
const toNumber = (value) => {
  if (value === null || value === undefined || value === '') return 0;
  if (typeof value === 'string') {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  }
  return typeof value === 'number' ? value : 0;
};

const formatCurrency = (amount) => {
  // Handle both string and number inputs
  const numAmount = toNumber(amount);
  return new Intl.NumberFormat('en-PK', {
    style: 'currency',
    currency: 'PKR'
  }).format(numAmount);
};

const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString('en-PK');
};

const buildShowroomHeader = (showroomDetails = {}) => {
  const name = showroomDetails.showroomName || showroomDetails.name || 'Showroom';
  const contact = showroomDetails.showroomPhone || showroomDetails.contact || '+92-XXX-XXXXXXX';
  const email = showroomDetails.showroomEmail || showroomDetails.email || 'info@showroom.com';
  const address = showroomDetails.showroomAddress || showroomDetails.address || 'N/A';
  const initials = name
    .split(' ')
    .filter(Boolean)
    .map(part => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase() || 'SM';

  return `
    <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
      <div style="width: 64px; height: 64px; border-radius: 10px; background-color: #eef2ff; color: #4338ca; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 18px; border: 1px solid #e5e7eb;">
        ${initials}
      </div>
      <div style="text-align: left;">
        <div style="font-size: 18px; font-weight: 700; margin-bottom: 4px;">${name}</div>
        <div style="font-size: 11px; color: #6b7280; margin-bottom: 2px;">Address: ${address}</div>
        <div style="font-size: 11px; color: #6b7280; margin-bottom: 2px;">Contact: ${contact}</div>
        <div style="font-size: 11px; color: #6b7280;">Email: ${email}</div>
      </div>
    </div>
  `;
};

const buildDoContent = (doData, type, showroomDetails = {}) => {
  const isPurchase = type === 'purchase';
  const dealInfo = isPurchase ? doData.purchaseInfo : doData.sellInfo;

  return `
    <div style="text-align: center; margin-bottom: 16px; border-bottom: 2px solid #111827; padding-bottom: 12px;">
      ${buildShowroomHeader(showroomDetails || doData.showroomDetails || {})}
      <div style="font-size: 16px; font-weight: 700; margin-top: 4px;">${isPurchase ? 'PURCHASE' : 'SELL'} DELIVERY ORDER</div>
      <div style="font-size: 11px; margin-bottom: 4px;"><strong>DO Number:</strong> ${doData.doNumber}</div>
      <div style="font-size: 11px; margin-bottom: 4px;"><strong>Deal ID:</strong> ${doData.dealId}</div>
      <div style="font-size: 11px; margin-bottom: 4px;"><strong>Deal Date:</strong> ${formatDate(doData.dealDate)}</div>
      <div style="font-size: 11px;"><strong>Generated Date:</strong> ${formatDate(doData.generatedDate)}</div>
    </div>
    
    <div style="display: flex; gap: 16px; margin-bottom: 12px;">
      <div style="flex: 1; padding: 10px; background-color: #f9fafb; border-radius: 8px; border: 1px solid #e5e7eb;">
        <h4 style="margin: 0 0 8px 0; font-size: 14px;">${isPurchase ? 'Seller' : 'Buyer'} Information</h4>
        <p style="margin: 3px 0; font-size: 11px;"><strong>Name:</strong> ${doData.customer?.fullName || 'N/A'}</p>
        <p style="margin: 3px 0; font-size: 11px;"><strong>CNIC:</strong> ${doData.customer?.cnic || 'N/A'}</p>
        <p style="margin: 3px 0; font-size: 11px;"><strong>Phone:</strong> ${doData.customer?.phoneNumber || 'N/A'}</p>
        <p style="margin: 3px 0; font-size: 11px;"><strong>Address:</strong> ${doData.customer?.address || 'N/A'}</p>
        ${doData.customer?.showroomName ? `<p style="margin: 3px 0; font-size: 11px;"><strong>Showroom:</strong> ${doData.customer.showroomName}</p>` : ''}
      </div>
      
      <div style="flex: 1; padding: 10px; background-color: #f9fafb; border-radius: 8px; border: 1px solid #e5e7eb;">
        <h4 style="margin: 0 0 8px 0; font-size: 14px;">Vehicle Information</h4>
        <p style="margin: 3px 0; font-size: 11px;"><strong>Vehicle:</strong> ${doData.car?.name} ${doData.car?.vehicleModel}</p>
        <p style="margin: 3px 0; font-size: 11px;"><strong>Make:</strong> ${doData.car?.vehicleMake || 'N/A'}</p>
        <p style="margin: 3px 0; font-size: 11px;"><strong>Registration:</strong> ${doData.car?.registrationNumber || 'N/A'}</p>
        <p style="margin: 3px 0; font-size: 11px;"><strong>Chassis:</strong> ${doData.car?.chassisNumber || 'N/A'}</p>
        <p style="margin: 3px 0; font-size: 11px;"><strong>Engine:</strong> ${doData.car?.engineNumber || 'N/A'}</p>
        <p style="margin: 3px 0; font-size: 11px;"><strong>Color:</strong> ${doData.car?.color || 'N/A'}</p>
        <p style="margin: 3px 0; font-size: 11px;"><strong>Condition:</strong> ${doData.car?.condition || 'N/A'}</p>
      </div>
    </div>
    
    <div style="margin-bottom: 12px; padding: 10px; background-color: #f0f8ff; border-radius: 8px; border: 1px solid #e5e7eb;">
      <h4 style="margin: 0 0 8px 0; font-size: 14px;">Transaction Details</h4>
      <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
        <span style="font-size: 11px;"><strong>Total Amount:</strong></span>
        <span style="font-size: 11px; font-weight: bold;">${formatCurrency(doData.totalAmount)}</span>
      </div>
      <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
        <span style="font-size: 11px;"><strong>Received Amount:</strong></span>
        <span style="font-size: 11px;">${formatCurrency(doData.receivedAmount)}</span>
      </div>
      <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
        <span style="font-size: 11px;"><strong>Outstanding Amount:</strong></span>
        <span style="font-size: 11px; font-weight: bold; color: #dc2626;">${formatCurrency(doData.outstandingAmount)}</span>
      </div>
      <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
        <span style="font-size: 11px;"><strong>Files Received:</strong></span>
        <span style="font-size: 11px; font-weight: bold; color: ${dealInfo?.filesReceived ? '#166534' : '#dc2626'};">${dealInfo?.filesReceived ? 'Yes' : 'No'}</span>
      </div>
      <div style="display: flex; justify-content: space-between;">
        <span style="font-size: 11px;"><strong>Number Plates Received:</strong></span>
        <span style="font-size: 11px; font-weight: bold; color: ${dealInfo?.numberPlatesReceived ? '#166534' : '#dc2626'};">${dealInfo?.numberPlatesReceived ? 'Yes' : 'No'}</span>
      </div>
    </div>
    
    ${doData.paymentStructures && doData.paymentStructures.length > 0 ? `
    <div style="margin-bottom: 12px;">
      <h4 style="margin: 0 0 8px 0; font-size: 14px;">Payment Schedule</h4>
      <table style="width: 100%; border-collapse: collapse; font-size: 10px;">
        <thead>
          <tr style="background-color: #f3f4f6;">
            <th style="border: 1px solid #e5e7eb; padding: 6px; text-align: left; font-weight: bold;">Description</th>
            <th style="border: 1px solid #e5e7eb; padding: 6px; text-align: left; font-weight: bold;">Amount</th>
            <th style="border: 1px solid #e5e7eb; padding: 6px; text-align: left; font-weight: bold;">Due Date</th>
            <th style="border: 1px solid #e5e7eb; padding: 6px; text-align: left; font-weight: bold;">Status</th>
          </tr>
        </thead>
        <tbody>
          ${doData.paymentStructures.map((payment) => `
            <tr>
              <td style="border: 1px solid #e5e7eb; padding: 6px; text-align: left;">${payment.description || 'Payment'}</td>
              <td style="border: 1px solid #e5e7eb; padding: 6px; text-align: left;">${formatCurrency(payment.amount)}</td>
              <td style="border: 1px solid #e5e7eb; padding: 6px; text-align: left;">${formatDate(payment.dueDate)}</td>
              <td style="border: 1px solid #e5e7eb; padding: 6px; text-align: left;">
                <span style="padding: 2px 6px; border-radius: 3px; font-size: 9px; background-color: ${payment.status === 'RECEIVED' || payment.status === 'GIVEN' ? '#dcfce7' : '#fef3c7'}; color: ${payment.status === 'RECEIVED' || payment.status === 'GIVEN' ? '#166534' : '#92400e'};">
                  ${payment.status}
                </span>
              </td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    </div>
    ` : ''}
    
    <div style="display: flex; justify-content: space-between; margin-top: 16px; padding-top: 14px; border-top: 1px solid #e5e7eb;">
      <div style="text-align: center; flex: 1;">
        <p style="margin: 0 0 18px 0; font-size: 11px;">Customer Signature</p>
        <div style="border-bottom: 1px solid #000; width: 150px; margin: 0 auto;"></div>
      </div>
      <div style="text-align: center; flex: 1;">
        <p style="margin: 0 0 18px 0; font-size: 11px;">Authorized Signature</p>
        <div style="border-bottom: 1px solid #000; width: 150px; margin: 0 auto;"></div>
      </div>
    </div>
    
    <div style="text-align: center; margin-top: 12px; font-size: 10px; color: #6b7280;">
      <p style="margin: 3px 0;">Generated on: ${formatDate(doData.generatedDate)}</p>
      <p style="margin: 3px 0;">This is a computer-generated document</p>
    </div>
  `;
};

const exportDeliveryOrderPDF = async (doData, type = 'purchase', showroomDetails = {}, onProgress) => {
  if (!doData) return;

  let pdfContent = null;
  try {
    // Show loading state
    if (onProgress) onProgress(true);

    const { default: jsPDF } = await import('jspdf');
    const html2canvas = await import('html2canvas');

    pdfContent = document.createElement('div');
    pdfContent.style.position = 'absolute';
    pdfContent.style.left = '-9999px';
    pdfContent.style.top = '0';
    pdfContent.style.width = '800px';
    pdfContent.style.padding = '20px';
    pdfContent.style.fontFamily = 'Arial, sans-serif';
    pdfContent.style.backgroundColor = 'white';
    pdfContent.style.color = 'black';
    pdfContent.style.fontSize = '12px';
    pdfContent.style.lineHeight = '1.3';

    pdfContent.innerHTML = buildDoContent(doData, type, showroomDetails || doData.showroomDetails || {});
    document.body.appendChild(pdfContent);

    // Convert to canvas - optimized for speed (scale 1 = fastest, still good quality)
    const canvas = await html2canvas.default(pdfContent, {
      scale: 1, // Reduced from 2 for much faster rendering
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: false,
      removeContainer: true
    });

    document.body.removeChild(pdfContent);
    pdfContent = null;

    // Use JPEG with quality for faster processing (smaller file, faster conversion)
    const imgData = canvas.toDataURL('image/jpeg', 0.92);
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    if (imgHeight <= pageHeight) {
      pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
    } else {
      const scale = pageHeight / imgHeight;
      const scaledWidth = imgWidth * scale;
      const scaledHeight = imgHeight * scale;
      const xOffset = (imgWidth - scaledWidth) / 2;
      pdf.addImage(imgData, 'JPEG', xOffset, 0, scaledWidth, scaledHeight);
    }

    // Add footer to all pages
    const totalPages = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i);
      pdf.setFontSize(8);
      pdf.setTextColor(100, 100, 100);
      pdf.text('powered by ledger Glide | +923332416545', imgWidth - 10, pageHeight - 5, { align: 'right' });
    }

    const fileName = `${type === 'purchase' ? 'purchase' : 'sell'}_do_${doData.doNumber || doData.dealId}_${new Date().toISOString().split('T')[0]}.pdf`;
    pdf.save(fileName);
    
    if (onProgress) onProgress(false);
  } catch (error) {
    console.error('Error generating DO PDF:', error);
    if (pdfContent && pdfContent.parentNode) {
      document.body.removeChild(pdfContent);
    }
    if (onProgress) onProgress(false);
    alert('Error generating PDF. Please try again.');
  }
};

export default exportDeliveryOrderPDF;